<template>
  <ContentSection permissions="Feedback and Complaint Customer Issue" :detail="customerIssue"
    approval-title="Investigation Customer Issue" @on-revision="handleRevision" @on-approve="handleApprove"
    @on-close="handleClose" revision-from-text="Tech Mkt Supp Manager" nextStep="the settlement process">
    <template #initial-form>
      <div>
        <div
          v-permissions="'View All Feedback and Complaint Customer Issues,View Feedback and Complaint Customer Issues,Create Feedback and Complaint Customer Issue,Edit Feedback and Complaint Customer Issue'"
          v-if="!customerIssue || (customerIssue && customerIssue?.status?.value === 'pending')"
          class="white-box mm15 p30 mb-3" style="min-height: auto;">
          <div class="popup-item p-0">
            <div class="row">
              <div class="col-sm-12">
                <div class="d-flex flex-row justify-content-between align-items-center mb-4">
                  <div class="ft-16 font-bold">Investigation Customer Issue (Tech Sales Supp)</div>
                </div>
                <div class="d-flex flex-column gap-2">
                  <div v-if="customerIssue"
                    class=" btn-border-green border-dashed rounded w-100 p-3 d-flex align-items-center justify-content-between">
                    <div class="ft-14 d-flex flex-row justify-content-between align-items-center">
                      <img :src="IconCheck" alt="check" style="margin-right: 8px;" />
                      <span>Customer Issue</span>
                    </div>
                    <button class="btn btn-see ft-14"
                      @click="$router.push(`/feedback/${$route.params.id}/customer-issue/edit`)">
                      Edit
                    </button>
                  </div>
                  <router-link v-else :to="`/feedback/${$route.params.id}/customer-issue`"
                    class="btn btn-border-orange border-dashed w-100">Input Customer Issue</router-link>
                  <button @click="onSubmit" :disabled="!customerIssue" type="button"
                    class="btn btn-orange w-100">Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #submitted-form="{ toggleCollapse, isCollapse, openModal, closeModal, modal }">
      <div v-if="customerIssue && !['pending'].includes(customerIssue?.status?.value)" class="white-box mm15 p30 mb-3"
        style="min-height: auto;">
        <div class="popup-item p-0">
          <div class="row">
            <div class="col-sm-12">
              <div class="d-flex flex-row justify-content-between align-items-center">
                <div class="ft-16 font-bold">Investigation Customer Issue (Tech Sales Supp)</div>
                <button @click="toggleCollapse" class="btn btn-transparent" :class="{ 'rotate': isCollapse }"><span
                    class="icon-ico-arrow-down"></span></button>
              </div>
              <div class="card-content" :class="{ 'show': isCollapse }">
                <div class="popup-item">
                  <div class="row">
                    <div class="col-sm-6 col-6">
                      <div class="grey">Preventive Action</div>
                      <span>{{ customerIssue?.preventive_action }}</span>
                    </div>
                    <div class="col-sm-6 col-6">
                      <div class="grey">Corrective Action</div>
                      <span>{{ customerIssue?.corrective_action }}</span>
                    </div>
                  </div>
                </div>
                <button @click="openModal('detail')" class="btn btn-see ft-14 mt-3">
                  Show detail
                </button>
              </div>
            </div>
          </div>
        </div>
        <!-- Detail Modal -->
        <div class="popup-wrapper" :class="{ 'showing': modal.detail }">
          <div class="popup-card p25">
            <div class="d-flex justify-content-between align-items-center">
              <div class="font-bold">Investigation Customer Issue (Tech Sales Supp)</div>
              <button @click="closeModal('detail')" class="btn btn-for-close"><span
                  class="icon-ico-close"></span></button>
            </div>
            <div class="inner-land" style="max-height: 80vh; overflow-y: auto; overflow-x: hidden;">
              <div class="popup-item wb">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Distribute to</div>
                    <span>{{ customerIssue?.distribute_to }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Date</div>
                    <span>{{ customerIssue?.date ? moment(customerIssue?.date, 'YYYY-MM-DD').format('DD-MM-YYYY') : '-'
                      }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Description</div>
                    <span>{{ customerIssue?.description }}</span>

                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Preventive Action</div>
                    <span>{{ customerIssue?.preventive_action }}</span>
                  </div>
                  <div class="col-sm-6 col-6">
                    <div class="grey">Corrective Action</div>
                    <span>{{ customerIssue?.corrective_action }}</span>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-12">
                    <div class="grey">Photo</div>
                    <div class="d-flex flex-row gap-2" style="flex-wrap: wrap;">
                      <img v-for="photo in customerIssue?.photos" :src="photo" :alt="photo" :key="photo"
                        style="max-width: 186px;" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="popup-item">
                <div class="row">
                  <div class="col-sm-6 col-6">
                    <div class="grey">Prepared by</div>
                    <span>{{ customerIssue?.tech_mkt_support?.name }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>

    <template #cta-edit-form>
      <div>
        <button v-permissions="'Create Feedback and Complaint Customer Issue,Edit Feedback and Complaint Customer Issue'" @click="$router.push(`/feedback/${$route.params.id}/customer-issue/edit`)"
          class="btn btn-orange mm15 w-100">Edit Customer Issue</button>
      </div>
    </template>
  </ContentSection>
</template>
<script>
import IconCheck from '@/assets/icons/check.svg';
import axios from '@/axios';
import { showErrorMessage } from '@/utils';
import ContentSection from '../Content';
import moment from 'moment';
export default {
  name: "FNCDetailCustomerIssue",
  components: {
    ContentSection
  },
  data() {
    return {
      IconCheck,
      moment
    }
  },
  async created() {
    this.$store.dispatch('getDetailFeedbackComplaintCustomerIssue', this.$route.params.id)
  },
  methods: {
    async onSubmit() {
      try {
        const { data: responseData, status } = await axios.put(`/fnc-customer-issues/${this.$route.params.id}`, {
          status: "waiting_approval"
        });
        if (status === 200 && responseData?.data) {
          // refresh internal issue detail
          this.refreshData()
        }
      } catch (error) {
        showErrorMessage(error);
      }
    },
    async handleRevision(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-customer-issues/${this.$route.params.id}`, {
          status: 'revision',
          revision: payload.reason
        })
        this.$notify({ type: 'success', text: 'Revision sent!' })
        if (payload.callback) payload.callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleApprove(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-customer-issues/${this.$route.params.id}`, {
          status: 'approved',
          continue: true
        })
        this.$notify({ type: 'success', text: 'Feedback Approved!' })
        if (payload.callback) payload.callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    async handleClose(payload) {
      try {
        this.$store.dispatch('toggleLoadingProgress', true)
        await axios.put(`/fnc-customer-issues/${this.$route.params.id}`, {
          status: 'approved',
          continue: false
        })
        this.$notify({ type: 'success', text: 'Feedback Closed!' })
        if (payload.callback) payload.callback()
        this.refreshData()
      } catch (error) {
        showErrorMessage(error)
      } finally {
        this.$store.dispatch('toggleLoadingProgress', false)
      }
    },
    refreshData() {
      this.$store.dispatch('getDetailFeedbackComplaint', this.$route.params.id)
      this.$store.dispatch('getDetailFeedbackComplaintCustomerIssue', this.$route.params.id)
    },
  },
  computed: {
    AppActiveUser() { return this.$store.state.AppActiveUser },
    customerIssue() {
      return this.$store.state?.feedbackComplaint?.customerIssue
    },
  },
}
</script>
